export default __webpack_public_path__ + "static/media/about_teamwork.429f3684.png";